import patchedToLocaleString from '../lib/patchedToLocaleString.js';

const formatCurrency = (locale, unitSystem, number, options = {}) => {
  const optionsWithDefaults = {
    style: 'currency',
    ...options
  };
  return patchedToLocaleString(number, locale, optionsWithDefaults);
};

export default formatCurrency;
